import {translate} from 'views/module';

const generateFilterOptions = () => {
  const filterOptions = {};

  filterOptions.searchString = {
    key: 'searchString',
    label: translate('client.ClientList.Filter.Search'),
    rank: 0,
    type: 'text',
    options: null,
    canBeEmpty: false,
  };

  filterOptions.status = {
    key: 'status',
    label: translate('client.ClientList.Filter.Status'),
    rank: 1,
    options: Object.entries(translate('client.Status'))
        .filter(([key]) => key === 'ACTIVE' || key === 'INACTIVE')
        .reduce((acc, [key, value], index) => {
          acc[key] = {
            label: value.Title,
            rank: index,
            key: key,
          };
          return acc;
        }, {}),
    canBeEmpty: false,
  };


  return filterOptions;
};

export {
  generateFilterOptions,
};
